import { Component, OnInit } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { SimpleFieldConfig } from '../simple-field.interface';


@Component({
  selector: "app-checkbox",
  template: `
<div class="demo-full-width margin-top" [formGroup]="group">
<mat-checkbox [formControlName]="field.name">{{field.label}}</mat-checkbox>
<ng-container *ngFor="let validation of field['dynamicFormLabelValidator'];">
<mat-error *ngIf="group?.get(field.name) && (group.get(field.name).hasError(validation.name) || (validation.name === 'required' && !group.get(field.name).value)) && (group.get(field.name).touched || group.get(field.name).dirty)">{{validation.message}}</mat-error>
</ng-container>
</div>
`,
  styles: [`
    mat-error {
      color: #f44336;
      font-size: 12px;
      display: block;
      margin-top: 4px;
    }
  `]
})
export class CheckboxComponent implements OnInit {
  field: SimpleFieldConfig;
  group: UntypedFormGroup;
  constructor() { }
  ngOnInit() { }
}
